var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".edit_svg__st0{fill:#bbbdc7}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "edit_svg__st0",
    d: "M22.4,32.5H4.3c-3.2,0-5.8-2.6-5.8-5.8V4.3c0-3.2,2.6-5.8,5.8-5.8h13.9c0.8,0,1.5,0.7,1.5,1.5S19,1.5,18.2,1.5 H4.3c-1.5,0-2.8,1.2-2.8,2.8v22.4c0,1.5,1.2,2.8,2.8,2.8h18.2c3.9,0,7.1-3.2,7.1-7.1v-9.6c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5 v9.6C32.5,28,28,32.5,22.4,32.5z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit_svg__st0",
    d: "M14,18.5c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l17-17c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1 l-17,17C14.8,18.4,14.4,18.5,14,18.5z",
    transform: "translate(4 4)"
  }))));
};
export default SvgEdit;